import {makeStyles} from '@material-ui/core/styles'
import {DeleteIconButton, Text} from '../../1elements'
import CollapseForCard from '../../2compounds/CollapseForCard'
import SubCollapseForCard from '../../2compounds/SubCollapseForCard'
import SelectTerritoriesModal from './SelectTerritoriesModal'
import {useEffect, useState} from 'react'
import {
    checkSelected,
    removeItemFromArray,
    selectedCounter,
    uncheckItem
} from '../../../services/util/miscellaneousService'
import SelectBusinessesModal from './SelectBusinessesModal'
import SubSubCollapseForCard from '../../2compounds/SubSubCollapseForCard'

const SelectResourceSet = ({showError, territories, setTerritories, businesses, setBusinesses}) => {
    const classes = useStyles()
    const [openTerritories, setOpenTerritories] = useState(false)
    const openTerritoriesModal = () => {
        setOpenTerritories(true)
    }
    const [openBusinesses, setOpenBusinesses] = useState(false)
    const openBusinessesModal = () => {
        setOpenBusinesses(true)
    }

    const header = (
        <>
            Assigned Entity Set
            <span className={'requiredAsterisk'}>*</span>
        </>
    )

    const headerTerritories = 'Territories'
    const [territoryGroup, setTerritoryGroup] = useState({
        'Country': [],
        'Province': []
    })
    const headerBusinesses = 'Businesses'

    const errorHandlerTerritories = () => {
        const selected = checkSelected(territories)
        if(showError&&!selected){
            return 'Assign at least one territory'
        }
    }

    const selectedTerritoriesCount = selectedCounter(territories)
    const selectedBusinessesCount = businesses.length
    const totalCount = selectedTerritoriesCount + selectedBusinessesCount

    const deleteTerritoryHandler = (territory) => {
        const updatedList = uncheckItem(territories, territory, 'name')

        setTerritories(updatedList)
    }

    const deleteBusinessHandler = (business) => {
        const updatedList = removeItemFromArray(businesses, business, 'resource_id')
        setBusinesses(updatedList)
    }

    useEffect(()=>{
        const copy = {
            'Country': [],
            'Province': []
        }

        for(let i = 0; i < territories.length; i++){
            const {name, selected} = territories[i]
            if(selected){
                name==='Canada'
                    ? copy['Country'].push(territories[i])
                    : copy['Province'].push(territories[i])
            }
        }

        setTerritoryGroup(copy)
    }, [territories])

    return (
        <>
            <CollapseForCard header={header} dataCount={totalCount} noAddButton>
                <div className={classes.innerDiv}>
                    {/* Territories */}
                    <SubCollapseForCard header={headerTerritories} dataCount={selectedTerritoriesCount} onClick={openTerritoriesModal}>
                        {Object.keys(territoryGroup).map((group)=>(
                            <SubSubCollapseForCard header={group} dataCount={territoryGroup[group].length}>
                                {territoryGroup[group].map((territory, index)=>(
                                    <div className={classes.territoryDeleteDiv} key={index}>
                                        <Text type='detailInfoHead'>{territory.name}</Text>
                                        <DeleteIconButton onClick={()=>deleteTerritoryHandler(territory.name)} />
                                    </div>
                                ))}
                            </SubSubCollapseForCard>
                        ))}
                    </SubCollapseForCard>
                    <SelectTerritoriesModal territories={territories}
                                            setTerritories={setTerritories}
                                            open={openTerritories}
                                            setOpen={setOpenTerritories} />

                    {/* Businesses */}
                    <SubCollapseForCard header={headerBusinesses} dataCount={selectedBusinessesCount} onClick={openBusinessesModal}>
                        {businesses.map((business, index)=>(
                            <div className={classes.territoryDeleteDiv} key={index}>
                                <Text type='detailInfoHead'>{business.name}</Text>
                                <DeleteIconButton onClick={()=> deleteBusinessHandler(business.resource_id)} />
                            </div>
                        ))}
                    </SubCollapseForCard>
                    <SelectBusinessesModal  businesses={businesses}
                                            setBusinesses={setBusinesses}
                                            open={openBusinesses}
                                            setOpen={setOpenBusinesses} />
                </div>
            </CollapseForCard>
            <div className={classes.errorMessageDiv}>
                <Text type='textFieldError'>{errorHandlerTerritories()}</Text>
            </div>
        </>
    )
}

export default SelectResourceSet

const useStyles = makeStyles({
    innerDiv: {
        marginLeft: '10px'
    },
    errorMessageDiv: {
        margin: '0 14px'
    },
    territoryDeleteDiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
})